
export {Accessibility,
Command,
CommandCollection,
Context,
ContextPlugin,
EditingKeystrokeHandler,
Editor,
ElementApiMixin,
MultiCommand,
PendingActions,
Plugin,
_DEFAULT_ACCESSIBILITY_GROUP_ID,
_getEditorUsageData,
attachToForm,
secureSourceElement} from '../../../frontend-editor-ckeditor-web/__liferay__/exports/@ckeditor$ckeditor5-core$dist$index.js.js';
